
module.filter('efl', function(eflNumberFilter, eflNames) {
    return function(val) {
        var efl = eflNumberFilter(val);
        if (efl) {
            return eflNames[efl - 3] + " (EFL " + efl + ")";
        }
    };
});
